<template>
  <div class="technology-grid-container">
    <div v-if="supplierId == 622">
      <!-- RUBRICA -->
       <div class="vx-row mb-8">
        <div class="vx-col w-1/2">
          <vx-card class="w-full cursor-pointer p-6">
            <div slot="no-body">
              <h5>Rangos de calificación de la empresa</h5>
              <vs-table stripe :data="rangeCompany">
                <template slot="thead" class="thead-dark">
                  <vs-th>Inferior</vs-th>
                  <vs-th>Superior</vs-th>
                  <vs-th>Nivel</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index" v-for="(range, index) in data">
                    <vs-td>{{range.low}}</vs-td>
                    <vs-td>{{range.high}}</vs-td>
                    <vs-td>{{range.level}}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-1/2">
          <vx-card class="w-full cursor-pointer p-6">
            <div slot="no-body">
              <h5>Rangos de calificación del perfil de la empresa</h5>
              <vs-table stripe :data="rangeProfile">
                <template slot="thead" class="thead-dark">
                  <vs-th>Inferior</vs-th>
                  <vs-th>Superior</vs-th>
                  <vs-th>Nivel</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index" v-for="(range, index) in data">
                    <vs-td>{{range.low}}</vs-td>
                    <vs-td>{{range.high}}</vs-td>
                    <vs-td>{{range.level}}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>
      <!-- TABLA DE SCORE -->
      <div class="vx-row mb-8"> 
        <div class="vx-col w-full">

          <vx-card class="overflow-hidden mt-5">
            <div slot="no-body">
              <!-- HEADER -->
              <div class="p-6" :class="['flex justify-between flex-row-reverse items-center']">
                <feather-icon
                    icon="AwardIcon" class="p-3 inline-flex rounded-full"
                    :class="[`text-primary`]"
                    :style="{background: `rgba(var(--vs-primary),.15)`}"></feather-icon>
                <div class="truncate">
                  <h3 class='mb-1 font-bold' :style="`color:#000000`">73.33</h3>
                  <span>SISTEMA FOTOVOLTAICO</span>
                </div>
              </div>

              <!-- TABLE -->
              <risk-model-result-table
                v-if="fakeScore"
                :result="fakeScore" />

            </div>
          </vx-card>
          
        </div>
      </div>

      <!-- TABLA GENERAL -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card>
            <div slot="no-body">
             <!-- HEADER -->
              <div class="p-6" :class="['flex justify-between flex-row-reverse items-center']">
                <feather-icon
                    icon="AwardIcon" class="p-3 inline-flex rounded-full"
                    :class="[`text-primary`]"
                    :style="{background: `rgba(var(--vs-primary),.15)`}"></feather-icon>
                <div class="truncate">
                  <h3 class='mb-1 font-bold' :style="`color:#000000`">88.83</h3>
                  <span>Calificación global de instalador</span>
                </div>
              </div>
              <vs-table stripe :data="globalData">
                <template slot="thead" class="thead-dark">
                  <vs-th>Categoría</vs-th>
                  <vs-th>Peso de la categoría</vs-th>
                  <vs-th>Resultado de la categoría</vs-th>
                  <vs-th>Porcentaje Global</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index" v-for="(range, index) in data">
                    <vs-td>{{range.category}}</vs-td>
                    <vs-td>{{range.weight}} %</vs-td>
                    <vs-td>{{range.result}} %</vs-td>
                    <vs-td>{{range.global}} %</vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td></vs-td>
                    <vs-td></vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td></vs-td>
                    <vs-td></vs-td>
                    <vs-td><strong>Calificación Global del Instalador</strong></vs-td>
                    <vs-td><strong>88.83 %</strong></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>

    </div>

    <div v-else>
      <vx-card
        class="flex mb-5 w-12/12 cursor-pointer p-6 hidden">
        <div slot="no-body">
          <h2 class="font-bold font">Calificación Final</h2>
          Score: {{totalScore|fixNumber}}
          <span :class="`text-danger`">
              <em class="fa fa-star"></em>
              <em class="fa fa-star"></em>
              <em class="fa fa-star"></em>
              <br>
              Detener Solicitudes
            </span>
        </div>
      </vx-card>

      <div class="row" v-if="reportResult">
        <div class="col-md-12" v-for="familyGroup in familyGroups" :key="familyGroup.id">
          <supplier-risk-model-by-tech-item
            :high-config="[60, 100]"
            :medium-config="[40, 59]"
            :low-config="[0, 39]"
            :family-group="familyGroup"
            :report="getFgProfileVerificationReport(familyGroup.id)"
            :supplier-id="supplierId"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SupplierRiskModelByTechItem
  from "@views/admin/RiskModel/Dashboard/RiskModel/SupplierRiskModel/ProfileVerificationResume/SupplierRiskModelByTechItem";
import {fixNumber} from "@/filters/NumberFilters";

// TEMP
import RiskModelResultTable from "@views/admin/RiskModel/Dashboard/RiskModel/RiskModelResultTable";

const fakeScore =
  {
    results: {
      groups: [
        { 
          name: "Perfil de la empresa"
          , weight: 100
          , result: 73.33
          , score: 73.33
          , rules: [
            {
              name: "Antigüedad de operación"
              , weight: 10
              , result: 10
              , score: 100
              , analysis_type: {
                type: "PositiveLine"
              }
              , answer: 5
              , worst_value: 1
              , best_value: 5
            },
            {
              name: "Ingeniería"
              , weight: 20
              , result: 20
              , score: 100
              , analysis_type: {
                type: "PositiveLine"
              }
              , answer: 48
              , worst_value: 34
              , best_value: 40
            },
            {
              name: "Capacidad instalada"
              , weight: 10
              , result: 10
              , score: 100
              , analysis_type: {
                type: "PositiveLine"
              }
              , answer: 4
              , worst_value: 1
              , best_value: 4
            },
            {
              name: "Capacidad de cuadrillas"
              , weight: 10
              , result: 3.33
              , score: 33.33
              , analysis_type: {
                type: "PositiveLine"
              }
              , answer: 2
              , worst_value: 1
              , best_value: 4
            },
            {
              name: "Personal de operación"
              , weight: 10
              , result: 0
              , score: 0
              , analysis_type: {
                type: "PositiveLine"
              }
              , answer: 0
              , worst_value: 2
              , best_value: 8
            },
            {
              name: "Alertas de historial crediticio"
              , weight: 10
              , result: 10
              , score: 100
              , analysis_type: {
                type: "InverseLine"
              }
              , answer: 0
              , worst_value: 0
              , best_value: 1
            },
            {
              name: "Comportamiento historial crediticio"
              , weight: 10
              , result: 0
              , score: 0
              , analysis_type: {
                type: "PositiveLine"
              }
              , answer: 0
              , worst_value: 0
              , best_value: 1
            },
            {
              name: "Testimonios y referencias"
              , weight: 10
              , result: 10
              , score: 100
              , analysis_type: {
                type: "PositiveLine"
              }
              , answer: 37.50
              , worst_value: 24
              , best_value: 35
            },
            {
              name: "Antigüedad de tecnología"
              , weight: 10
              , result: 10
              , score: 100
              , analysis_type: {
                type: "PositiveLine"
              }
              , answer: 5
              , worst_value: 0
              , best_value: 4
            }
          ]
        }
      ]
    }
  };

const rangeCompany = [
  { low: 90, high: 100, level: "Alto"}
  , { low: 80, high: 89, level: "Bueno"}
  , { low: 70, high: 79, level: "Limitado"}
  , { low: 0, high: 69, level: "Baja"}
];

const rangeProfile = [
  { low: 70, high: 100, level: "Verificable"}
  , { low: 60, high: 69, level: "No verificable, potencial"}
  , { low: 0, high: 59, level: "Rechazado"}
];

const globalData = [
  { category: "Perfil de la empresa", weight: 25, result: 73, global: 18.33}
  , { category: "Gestión de proyecto", weight: 20, result: 90, global: 18}
  , { category: "Calidad de proyecto", weight: 25, result: 90, global: 22.5}
  , { category: "Desempeño de la cobranza", weight: 30, result: 100, global: 30}
];

export default {
  name: "ProfileVerificationResume",
  components: {SupplierRiskModelByTechItem, RiskModelResultTable},
  props: {
    supplierId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    familyGroups: [],
    profileVerificationReport: {},
    reportResult: null,
    totalScore: 0,
    fakeScore: fakeScore,
    rangeCompany: rangeCompany,
    rangeProfile: rangeProfile,
    globalData: globalData
  }),
  filters: {
    fixNumber,
  },
  async mounted() {
    if(this.supplierId !== 622) {
      this.familyGroups = await this.getFamilyGroups(this.supplierId);
      await this.setReports();
    } else {
      // TODO:
    }
  },
  watch: {
    reportResult: function() {
      // this.calculateGeneralScore(this.reportResult)
    }
  },
  methods: {
    getFgProfileVerificationReport(familyGroupId) {
      if(this.profileVerificationReport[familyGroupId]) {
        return this.profileVerificationReport[familyGroupId];
      }
      return null;
    },
    /**
     * @return {Number[]}
     */
    getFamilyGroupIds() {
      return this.familyGroups.map((f) => f.id);
    },
    async setReports() {
      try {
        const { data } = await axios.post(`/api/risk-model/supplier-verification/all`, {
          supplierId: this.supplierId
        });

        this.reportResult = data;

        this.calculateGeneralScore(this.reportResult);
      } catch (e) {
        throw e;
      }
    },
    calculateGeneralScore(reports) {
      let totalScoreSum = 0;
      let counter = 0;

      for (let report of reports) {
        this.profileVerificationReport[report.family_group_id] = report.result;
        if(report.result !== null) {
          totalScoreSum += report.result.score;
        }
        counter++;
      }

      if(totalScoreSum > 0 && counter > 0) {
        this.totalScore = totalScoreSum / counter;
      }
      this.totalScore = 0;
    },
    async getFamilyGroups(supplierId) {
      try {
        const {data} = await axios.get(`/api/supplier/${supplierId}/family-groups`);
        return data;
      } catch (e) {
        return [];
      }
    },

  }
}
</script>

<style scoped>

</style>
